import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { ModuleWithProviders } from '@angular/core';

import { MessageService } from './message.service';
import { ToastComponent } from './toast/toast.component';
import { AlertComponent } from './alert/alert.component';
import { ConfirmComponent } from "./confirm/confirm.component";

@NgModule({
  imports: [CommonModule, FormsModule, MatDialogModule],
  exports: [ToastComponent, AlertComponent, ConfirmComponent],
  declarations: [ToastComponent, AlertComponent, ConfirmComponent],
})
export class RsmMessageModule {
  static forRoot(): ModuleWithProviders<RsmMessageModule> {
    return {
      ngModule: RsmMessageModule,
      providers: [MessageService],
    };
  }
}
